import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

export const TENT_NODES: IconNode = [
  [
    'path',
    {
      key: 'tent-0',
      d: 'M2.59985 10.5998L11.9999 4.7998L21.3999 10.5998',
    },
  ],
  [
    'path',
    {
      key: 'tent-1',
      d: 'M2.19995 10.5996H21.7999',
    },
  ],
  [
    'path',
    {
      key: 'tent-2',
      d: 'M5.3999 10.5996V19.3996',
    },
  ],
  [
    'path',
    {
      key: 'tent-3',
      d: 'M18.5999 10.5996V19.3996',
    },
  ],
  [
    'path',
    {
      key: 'tent-4',
      d: 'M12 10.5996V19.3996',
    },
  ],
]

export const TentIcon: LucideIcon = createLucideIcon('tent', TENT_NODES)
